import * as React from "react";
import { Component } from "react";
import styles from "../styles/wizards/AddPartToProductWizard.scss";
import autobind from "autobind-decorator";
import { __, mapStateToProps, setTableParams, validateForm } from "../core/utils";
import AddLinkedSpecificationIcon from "../assets/images/add-linked-specification-64x64.svg";
import { withRouter } from "react-router";
import AddPartToProductForm from "../forms/add_part_to_product_wizard/AddPartToProductForm";
import { addProductParts, readProduct } from "../redux/actions/table/products";
import { setNotification } from "../redux/actions/general/notification";

@mapStateToProps((state) => ({
	store: _.get(state.table, "products")
}))
@withRouter
class AddPartToProductWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		return validateForm(
			addProductParts(this.props.store.flyout.id, this.props.store.category, formData.product_ids).then(() =>
				readProduct(this.props.store.flyout.id).then(({ response }) => {
					setNotification(__("products.flyout.parts.parts-have-been-added"));

					setTableParams("products", {
						flyout: response.data
					});

					this.props.onClose();
				})
			)
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__("products.flyout.parts.add-part")}</span>
						<span>{__("products.flyout.parts.add-part")}</span>
					</div>
					<div className={styles.right}>
						<AddLinkedSpecificationIcon />
					</div>
				</div>
				<div className={styles.body}>
					<AddPartToProductForm
						onSubmit={this._handleSubmit}
						initialValues={{
							product_ids: []
						}}
					/>
				</div>
			</>
		);
	}
}

export default AddPartToProductWizard;
